export default __webpack_public_path__ + "static/media/silver.1980060a.png";